/**
 * @typedef {'front' | 'back'} BodyView
 * @typedef {'man' | 'woman'} BodyGender
 * @typedef {'left' | 'right' | 'central' | 'bilateral'} Laterality
 * @typedef {'radiating' | 'localized'} PainType
 * @typedef {'sharp' | 'dull' | 'burning' | 'aching'} PainQuality
 *
 * @typedef {Object} PointPct
 * @property {number} x
 * @property {number} y
 *
 * @typedef {Object} PainLocation
 * @property {BodyView} view
 * @property {PointPct | null} coordinates
 * @property {string | null} zone
 * @property {Laterality | null} laterality
 *
 * @typedef {Object} PainDataOutput
 * @property {BodyView} view
 * @property {'male' | 'female'} gender
 * @property {PainLocation} primary_location
 * @property {PainType} pain_type
 * @property {PainLocation | undefined} secondary_location
 * @property {PainQuality | null} quality
 * @property {number | null} intensity
 * @property {boolean | undefined} skip
 * @property {string} timestamp
 */

export const PAIN_MAPPING_STATES = {
  IDLE: 'IDLE',
  AWAITING_LOCATION: 'AWAITING_LOCATION',
  PENDING_CONFIRMATION: 'PENDING_CONFIRMATION',
  AWAITING_RADIATION_CHECK: 'AWAITING_RADIATION_CHECK',
  AWAITING_SECONDARY_LOCATION: 'AWAITING_SECONDARY_LOCATION',
  AWAITING_QUALITY_CHECK: 'AWAITING_QUALITY_CHECK',
  AWAITING_INTENSITY: 'AWAITING_INTENSITY',
  COMPLETE: 'COMPLETE',
};

